// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__GrHNp","avatar":"Profile_avatar__0foIh","chevron":"Profile_chevron__tvPxV","profileName":"Profile_profileName__fIlkL"};